interface SectionTitleProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  as?: "h1" | "h2" | "h3";
}

export default function SectionTitle({ title, subtitle, centered = true, as = "h2" }: SectionTitleProps) {
  const Heading = as;
  return (
    <div className={`mb-12 ${centered ? "text-center" : ""}`}>
      <Heading className="text-3xl md:text-4xl font-bold text-foreground mb-3">{title}</Heading>
      <div className={`w-20 h-1 bg-gradient-woody rounded-full mb-4 ${centered ? "mx-auto" : ""}`} />
      {subtitle && <p className="text-muted-foreground max-w-2xl mx-auto">{subtitle}</p>}
    </div>
  );
}
